/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState, useContext } from "react";
import fetchHelper from "../../services/fetchHelper";
import { useSelector } from "react-redux";
import { LayoutContext } from "../layout";
import "./notes.css";

const Notes = ({ isSubmit, isCancel, callback }) => {
  const {
    patient: { id: patientId },
  } = useSelector((state) => state.currentIR);
  const [message, setMessage] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [noteValidationMsg, setNoteValidationMsg] = useState(false);
  const [cat, setCat] = useState("clinical");
  const { user } = useContext(LayoutContext);

  useEffect(() => {
    if (isCancel) {
      resetForm();
      callback("cancel");
    }
  }, [isCancel]);

  useEffect(() => {
    if (isSubmit) {
      handleSubmit();
    }
  }, [isSubmit]);

  const handleSubmit = async () => {
    if (!message) {
      setNoteValidationMsg(true);
      return callback("invalidForm");
    } else {
      setNoteValidationMsg(false);
    }

    try {
      const body = { patient: { id: patientId }, note: message, sticky: isChecked, user, cat };
      const response = await fetchHelper.post("/patientmanagement/rest/patientnote/", body);
      resetForm();
      callback("submit", response);
    } catch (err) {
      console.log(err.message);
    }
  };

  const resetForm = () => {
    setMessage("");
    setIsChecked(false);
    setNoteValidationMsg(false);
  };

  return (
    <div className="row rowStretch location-row">
      <div className="col col-s-100 col-m-100 col100">
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className="form-li" style={{ width: "auto" }}>
            <input
              type="checkbox"
              className="chk"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
            />
            <span className="chkmrk" style={{ width: 10, marginBottom: 0 }}></span>
          </label>
          <span style={{ marginBottom: 5 }}>High-Priority? Priority notes will always show at top.</span>
        </div>
      </div>
      <div className="col col-s-100 col-m-50 col50" style={{ paddingLeft: 0 }}>
        <label className="inCal">
          <select name="category" value={cat} onChange={(e) => setCat(e.target.value)}>
            <option value="clinical">Clinical</option>
            <option value="pe">PE</option>
            <option value="admin">Admin</option>
          </select>
        </label>
      </div>
      <div className="col col-s-100 col-m-50 col50" />
      <div className="col col-s-100 col-m-100 col100">
        <label>
          <textarea
            value={message}
            placeholder="Enter note..."
            className="fullWidth fixed-size"
            onChange={(e) => {
              e.preventDefault();
              setMessage(e.target.value);
            }}
          />
        </label>
      </div>
      {noteValidationMsg && (
        <span className="error">Required fields missing data. Please review and re-submit.</span>
      )}
      <div className="col col-s-100 col-m-100 col50 showBs" />
    </div>
  );
};

export default Notes;
